export class RiderUploadDocModel {
	RiderId!: number;

	//Identification
	DriverProfessionalLicenceFrontImageUrl!: string;
	DriverProfessionalLicenceFrontImageUrlIsLoading: boolean = false;
	DriverProfessionalLicenceBackImageUrl!: string;
	DriverProfessionalLicenceBackImageUrlIsLoading: boolean = false;
	DriverProfessionalLicenceExpiryAt!: Date;
	DriverNBIClearanceImageUrl!: string;
	DriverNBIClearanceImageUrlIsLoading: boolean = false;
	DriverNBIClearanceExpiryAt!: Date;
	RidesharingAppImageUrl!: string;
	RidesharingAppImageUrlIsLoading: boolean = false;

	//Vehicle Documents
	LTOOfficialReceiptImageUrl!: string;
	LTOOfficialReceiptImageUrlIsLoading: boolean = false;
	LTOOfficialReceiptExpireAt!: Date;
	CertificateRegistrationImageUrl!: string;
	CertificateRegistrationImageUrlIsLoading: boolean = false;
	SPAImageUrl!: string;
	SPAImageUrlIsLoading: boolean = false;
	AuthorizationLetterImageUrl!: string;
	AuthorizationLetterImageUrlIsLoading: boolean = false;

	//TNVC Documents
	CertificatePublicConvenienceImageUrl!: string;
	CertificatePublicConvenienceImageUrlIsLoading: boolean = false;
	CertificatePublicConvenienceExpireAt!: Date;
	ProvisionalAuthorityImageUrl!: string;
	ProvisionalAuthorityImageUrlIsLoading: boolean = false;
	ProvisionalAuthorityExpireAt!: Date;
	PaOrCpcCaseNumber!: string;

	constructor(payload?: { [key: string]: any }) {
		Object.assign(this, payload);
	}

	public IsIdentificationFieldsFilled(): boolean {
		if (this.DriverProfessionalLicenceFrontImageUrl || this.DriverProfessionalLicenceBackImageUrl ||
			this.DriverNBIClearanceImageUrl || this.RidesharingAppImageUrl || this.DriverProfessionalLicenceExpiryAt ||
			this.DriverNBIClearanceExpiryAt) {
			return true;
		}

		return false;
	}

	public IsVehicleDocumentsFieldsFilled(): boolean {
		if (this.LTOOfficialReceiptImageUrl || this.CertificateRegistrationImageUrl ||
			this.SPAImageUrl || this.AuthorizationLetterImageUrl || this.LTOOfficialReceiptExpireAt) {
			return true;
		}

		return false;
	}

	public IsTNVCDocumentsFieldsFilled(): boolean {
		if (((this.CertificatePublicConvenienceImageUrl || this.ProvisionalAuthorityImageUrl) && this.PaOrCpcCaseNumber) ||
			this.CertificatePublicConvenienceExpireAt || this.ProvisionalAuthorityExpireAt) {
			return true;
		}

		return false;
	}
}
